import api from './api'

export const aliParking = {
  aliParkingPageList: (params) => {
    return api.post(`/CloudParkAPI/AliParkMain/AliParkingPageList`, params)
  },
  aliParkingInfo: (id) => {
    return api.get(`/CloudParkAPI/AliParkMain/AliParkingInfo/${id}`)
  },
  aliParkingEdit: (params) => {
    return api.post(`/CloudParkAPI/AliParkMain/AliParkingEdit`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/aliParking.js